export const ALFIE_EXPERIENCE = {
  simpleV2: 'simple_v2',
} as const

export type AlfieExperience =
  (typeof ALFIE_EXPERIENCE)[keyof typeof ALFIE_EXPERIENCE]
